<template>
        <v-dialog
            v-model="isDialogOpen"
            width="680px"
            overlay-opacity="0.8"
            fixed
            temporary
            right
        >
            <v-card class="pa-4">
                <v-card-title class="d-flex align-center v-application mb-8">
                    <p>Manuelle Einrichtung</p>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="isDialogOpen = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-alert v-if="current.trial_status === 'requested'" type="info" outlined dense>
                        Der Start aktiviert die separate Test-Steffi für volle 14 Tage ohne Kosten.
                        Anschließend beginnt das kostenpflichtige Abonnement automatisch, sofern die Testphase nicht beendet wurde.
                    </v-alert>
                    <v-row dense>
                        <v-col class="v-application--is-ltr" cols="6">
                            <v-text-field
                                v-model="manualSetupForm.famulor_assistant_id"
                                dense
                                outlined
                                label="Steffi Instanz ID"
                                :disabled="!canUpdateManualSetup"
                                data-test="steffi-assistant-id"
                            ></v-text-field>
                        </v-col>
                        <v-col class="v-application--is-ltr" cols="6">
                            <v-text-field
                                v-model="manualSetupForm.famulor_assistant_name"
                                dense
                                outlined
                                label="Steffi Instanz Name"
                                :disabled="!canUpdateManualSetup"
                            ></v-text-field>
                        </v-col>
                        <v-col class="v-application--is-ltr" cols="4">
                            <v-text-field
                                v-model="manualSetupForm.famulor_phone_id"
                                dense
                                outlined
                                label="Telefonnummer ID"
                                :disabled="!canUpdateManualSetup"
                                data-test="steffi-phone-id"
                            ></v-text-field>
                        </v-col>
                        <v-col class="v-application--is-ltr" cols="4">
                            <v-text-field
                                v-model="manualSetupForm.famulor_phone_number"
                                dense
                                outlined
                                label="Telefonnummer"
                                :disabled="!canUpdateManualSetup"
                                data-test="steffi-phone-number"
                            ></v-text-field>
                        </v-col>
                        <v-col class="v-application--is-ltr" cols="4">
                            <v-select
                                v-model="manualSetupForm.famulor_operational_status"
                                :items="operationalStatusItems"
                                dense
                                outlined
                                clearable
                                label="Technischer Status"
                                :disabled="!canUpdateManualSetup"
                            ></v-select>
                        </v-col>
                        <v-col class="v-application--is-ltr" cols="12">
                            <v-textarea
                                v-model="manualSetupForm.manual_setup_notes"
                                dense
                                outlined
                                auto-grow
                                rows="2"
                                hide-details
                                label="Notizen"
                                :disabled="!canUpdateManualSetup"
                            ></v-textarea>
                        </v-col>
                        <v-col class="v-application--is-ltr" cols="5">
                            <v-checkbox
                                v-model="manualSetupForm.technical_test_finished"
                                label="TechTest abgeschlossen"
                                :disabled="!canUpdateManualSetup"
                                class="mt-0"
                                data-test="steffi-technical-test-finished"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-text-field
                        v-if="current.can_activate || current.can_send_customer_access_email"
                        v-model="customerAccessPassword"
                        type="password"
                        autocomplete="new-password"
                        label="Passwort für die Steffi-Zugangsmail"
                        hint="Wird nur für diese Zugangsmail verwendet und nicht gespeichert."
                        persistent-hint
                        outlined
                        dense
                        class="mb-4"
                        data-test="steffi-access-password"
                    />
                    <v-alert
                        v-if="current.onboarding_notification_sent_at"
                        type="success"
                        dense
                        outlined
                        class="mb-2"
                    >
                        Interne Onboarding-Mail: {{ formatDate(current.onboarding_notification_sent_at) }}
                    </v-alert>
                    <v-alert
                        v-else-if="current.onboarding_notification_error"
                        type="warning"
                        dense
                        outlined
                        class="mb-2"
                    >
                        Interne Onboarding-Mail konnte nicht gesendet werden.
                    </v-alert>
                    <v-alert
                        v-if="current.customer_access_email_sent_at"
                        type="success"
                        dense
                        outlined
                        class="mb-2 sent-at"
                    >
                        Steffi-Zugang gesendet an {{ current.customer_access_email_recipient }}
                    </v-alert>
                    <v-alert
                        v-else-if="current.customer_access_email_error"
                        type="warning"
                        dense
                        outlined
                        class="mb-2"
                    >
                        Steffi-Zugangsmail konnte nicht gesendet werden.
                    </v-alert>
                    <v-alert
                        v-if="activationBlockerText"
                        type="info"
                        dense
                        outlined
                        class="mb-0"
                    >
                        Aktivierung noch nicht möglich: {{ activationBlockerText }}
                    </v-alert>
                </v-card-text>


                <v-card-actions class="v-application mt-4">
                    <v-btn
                        v-if="canUpdateManualSetup"
                        outlined
                        color="primary"
                        :loading="isSavingManualSetup"
                        data-test="steffi-save-manual-setup"
                        @click="saveManualSetup"
                    >
                        Speichern
                    </v-btn>
                    <v-btn
                        color="primary"
                        :disabled="!canRunActivationAction"
                        :loading="isActivating"
                        data-test="steffi-activate"
                        @click="activateSteffi"
                        class="ml-4"
                    >
                        {{ activationActionLabel }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex';
import axios from 'axios';

export default {
    name: 'SteffiManualSetupDrawer',
    props: {
        pharmacyId: {
            type: String,
            required: true,
        },
        current: {
            type: Object,
            default: () => ({}),
        },
        isRestricted: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Boolean,
            default: false,
        },
        routeGeneration: {
            type: Number,
            required: true,
        },
    },
    emits: ['context-updated'],
    data: () => ({
        manualSetupForm: {
            famulor_assistant_id: '',
            famulor_assistant_name: '',
            famulor_phone_id: '',
            famulor_phone_number: '',
            famulor_operational_status: '',
            manual_setup_notes: '',
            technical_test_finished: false,
        },
        operationalStatusItems: [
            { text: 'Aktiv', value: 'active' },
            { text: 'Inaktiv', value: 'inactive' },
            { text: 'Unbekannt', value: 'unknown' },
        ],
        isSavingManualSetup: false,
        isActivating: false,
        customerAccessPassword: '',
        isActive: true,
    }),
    computed: {
        isDialogOpen: {
            get() {
                return this.value;
            },
            set(val) {
                if (!val) this.customerAccessPassword = '';
                this.$emit('input', val);
            }
        },
        canUpdateManualSetup() {
            if (!this.isRestricted) return true;
            return Boolean(this.current.can_update_manual_setup);
        },
        canSendCustomerAccessEmail() {
            return !this.isActivating && Boolean(this.current.can_send_customer_access_email)
        },
        canRunActivationAction() {
            if (this.isActivating) return false;
            return this.canSendCustomerAccessEmail || Boolean(this.current.can_activate);
        },
        activationActionLabel() {
            if (this.current.trial_status === 'requested') return '14 Tage Testphase starten';
            return this.canSendCustomerAccessEmail
                ? 'Steffi-Zugangsmail erneut senden'
                : 'Aktivieren';
        },
        activationBlockerText() {
            const blockers = this.current.activation_blockers || [];
            return blockers.map(this.activationBlockerLabel).filter(Boolean).join(', ');
        },
    },
    watch: {
        value(isOpen) {
            if (!isOpen) this.customerAccessPassword = '';
        },
        current() {
            this.syncManualSetupForm();
        },
        routeGeneration() {
            this.isSavingManualSetup = false;
            this.isActivating = false;
            this.customerAccessPassword = '';
        },
    },
    created() {
        this.syncManualSetupForm();
    },
    methods: {
        isCurrentAction(pharmacyId, routeGeneration) {
            return this.isActive
                && this.pharmacyId === pharmacyId
                && this.routeGeneration === routeGeneration;
        },
        syncManualSetupForm() {
            this.manualSetupForm = {
                famulor_assistant_id: this.current.famulor_assistant_id || '',
                famulor_assistant_name: this.current.famulor_assistant_name || '',
                famulor_phone_id: this.current.famulor_phone_id || '',
                famulor_phone_number: this.current.famulor_phone_number || '',
                famulor_operational_status: this.current.famulor_operational_status || '',
                manual_setup_notes: this.current.manual_setup_notes || '',
                technical_test_finished: Boolean(this.current.technical_test_finished),
            };
        },
        async saveManualSetup() {
            if (!this.pharmacyId || this.isSavingManualSetup) return;
            const pharmacyId = this.pharmacyId;
            const routeGeneration = this.routeGeneration;
            try {
                this.isSavingManualSetup = true;
                const response = await axios.put(
                    `/api/pharmacies/${pharmacyId}/steffi/manual-setup`,
                    this.manualSetupForm,
                );
                if (!this.isCurrentAction(pharmacyId, routeGeneration)) return;
                this.$emit('context-updated', response.data, pharmacyId, routeGeneration);
                this.alertSuccess('Steffi Einrichtung gespeichert');
            } catch (error) {
                if (!this.isCurrentAction(pharmacyId, routeGeneration)) return;
                this.alertError(error?.response?.data?.message || 'Steffi Einrichtung konnte nicht gespeichert werden.');
            } finally {
                if (this.isCurrentAction(pharmacyId, routeGeneration)) {
                    this.isSavingManualSetup = false;
                    this.isDialogOpen = false;
                }
            }
        },
        async activateSteffi() {
            if (!this.pharmacyId || this.isActivating || !this.canRunActivationAction) return;
            const pharmacyId = this.pharmacyId;
            const routeGeneration = this.routeGeneration;
            const isAccessEmailRetry = this.canSendCustomerAccessEmail;
            const isTrialStart = this.current.trial_status === 'requested';
            try {
                this.isActivating = true;
                const response = await axios.post(`/api/pharmacies/${pharmacyId}/steffi/activate`, {
                    customer_access_password: this.customerAccessPassword || undefined,
                });
                if (!this.isCurrentAction(pharmacyId, routeGeneration)) return;
                this.$emit('context-updated', response.data, pharmacyId, routeGeneration);
                if (isAccessEmailRetry && !this.current.customer_access_email_sent_at) {
                    this.alertError('Steffi-Zugangsmail konnte nicht gesendet werden.');
                    return;
                }
                this.alertSuccess(isAccessEmailRetry ? 'Steffi-Zugangsmail wurde gesendet' : (isTrialStart ? 'Testphase wurde gestartet' : 'Steffi wurde aktiviert'));
            } catch (error) {
                if (!this.isCurrentAction(pharmacyId, routeGeneration)) return;
                this.alertError(error?.response?.data?.message || 'Steffi konnte nicht aktiviert werden.');
            } finally {
                if (this.isCurrentAction(pharmacyId, routeGeneration)) {
                    this.isActivating = false;
                    this.customerAccessPassword = '';
                    this.isDialogOpen = false;
                }
            }
        },
        activationBlockerLabel(blocker) {
            return {
                invalid_status: 'Status passt nicht',
                trial_expired: 'Testphase beendet',
                missing_famulor_assistant_id: 'Steffi Instanz ID fehlt',
                missing_famulor_phone: 'Telefonnummer fehlt',
            }[blocker] || blocker;
        },
        formatDate(date) {
            if (!date) return null;
            return this.$formatDate(date, 'DD.MM.YYYY HH:mm');
        },
        ...mapMutations({
            alertSuccess: 'alert/success',
            alertError: 'alert/error',
        }),
    },
    beforeDestroy() {
        this.isActive = false;
    },
}
</script>

<style scoped>
</style>
